import React from "react";
import { Button } from "@telegram-apps/telegram-ui";
import { TemporaryCoinsService } from "../../services/TemporaryCoinsService"; // Import temporary coins service
import { StorageService } from "../../services/LocalStorageService";
import "./EndGameScreen.css";

interface EndGameScreenProps {
  initialMoney: number;
  finalMoney: number;
  sessionGems?: number;
  onPlayAgain: () => void;
  onExit: () => void;
}

export function EndGameScreen({
  initialMoney,
  finalMoney,
  sessionGems = 0,
  onPlayAgain,
  onExit,
}: EndGameScreenProps) {
  const profit = finalMoney - initialMoney;
  const profitPercent = (profit / initialMoney) * 100;
  const isProfit = profit >= 0;

  // TEMPORARY: Calculate actual coin change for display
  const coinChange = isProfit ? profit : 0; // Losses are already handled by initial deduction
  const breakEven = profit === 0;

  return (
    <div className="end-game-overlay">
      <div className="end-game-modal">
        <div className="end-game-header">
          <h2 className="end-game-title">🏁 TRADING SESSION COMPLETE</h2>
          <div className="end-game-subtitle">Time's Up!</div>
        </div>

        <div className="end-game-results">
          <div className="money-row">
            <span className="money-label">Starting Capital:</span>
            <span className="money-value initial">
              ${initialMoney.toFixed(2)}
            </span>
          </div>

          <div className="money-row">
            <span className="money-label">Final Balance:</span>
            <span className="money-value final">${finalMoney.toFixed(2)}</span>
          </div>

          <div className="money-row">
            <span className="money-label">Gems earned this session:</span>
            <span className="money-value final">+{sessionGems}</span>
          </div>

          <div className="profit-loss-row">
            <div
              className={`profit-loss-result ${isProfit ? "profit" : "loss"}`}
            >
              <div className="profit-loss-amount">
                {isProfit ? "+" : ""}${profit.toFixed(2)}
              </div>
              <div className="profit-loss-percent">
                ({isProfit ? "+" : ""}
                {profitPercent.toFixed(1)}%)
              </div>
            </div>
          </div>

          <div className="performance-message">
            {profit > 100
              ? "🚀 Excellent trading!"
              : profit > 0
              ? "📈 Good job!"
              : profit > -50
              ? "📊 Not bad for a start!"
              : "📉 Better luck next time!"}
          </div>
        </div>

        <div className="end-game-actions">
          <Button size="l" onClick={onPlayAgain} className="play-again-button">
            🎮 Play Again
          </Button>

          <Button size="l" onClick={onExit} className="exit-button-endgame">
            🏠 Exit to Menu
          </Button>
        </div>
      </div>
    </div>
  );
}
